import template from './unitFinish.partial.html';
import controller from './unitFinish.controller';
import './unitFinish.scss';

let unitFinish = {
    bindings: {
        congratulationMessage: '<',
        finishSection: '<',
        finalDescription: '<',
        nextCourseButton: '<',
        dashboardButton: '<',
        nextCourse: '<',
        nextCourseDisabled: '<',
        showMessage: '<',
        currentCourseLastDiagramId: '<',
        onButtonClick: '&'
    },
    controllerAs: 'vm',
      template,
      controller,
      transclude: true
  };

export default unitFinish;



// WEBPACK FOOTER //
// ./client/app/blocks/unitFinish/unitFinish.component.js